import React, { useEffect } from 'react'
import { dynamicFailed } from '../../hooks/useToast';
import { checkUser } from '../../api/UserApi';
import { openLogin } from '../../exports/exports';
import { useLoader } from '../../context/LoaderContext';
// import { IMemberListData } from '../../exports/interfaces';
import { useUserDataContext } from '../../context/UserDataContext';
import { useNavigate } from 'react-router-dom';
import Notice from '../../components/user/member/Notice';

const MemberNotice = () => {
 const { setLoading } = useLoader();
//   const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const { userData, setUserData } = useUserDataContext();
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    setLoading(true);
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          // userData?.data?.status === "0" && navigate("/error");
          userData?.data?.roles[0]?.name !== "member" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, navigate, setLoading, setUserData, userData]);
  useEffect(() => {
    if (userData) {
      // userData?.data?.status === "0" && navigate("/error");
    //   Promise.all([fetchUserById(userData?.data?.id)])
    //     .then(([data]) => {
    //       setListMemberData(data);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        // })
        // .catch(() => {
        //   dynamicFailed("Server Error");
        //   setTimeout(() => {
        //     setLoading(false);
        //   }, 1000);
        // });
    }
  }, [setLoading, userData]);
  return (
    <>
      <Notice />
    </>
  );
}

export default MemberNotice